var OrderMenu = (function () {
    function OrderMenu() {
    }
    return OrderMenu;
}());
export { OrderMenu };
//# sourceMappingURL=order-menu.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/order/order-menu.js
// module id = 1131
// module chunks = 0